import notificaciones from "./notificaciones/notificaciones"

const equitas = {
    notificaciones: notificaciones
}

export default equitas


//////////////////
// WEBPACK FOOTER
// ./static/js/api/EQUITAS/sistema/equitas.js
// module id = null
// module chunks = 